<template>
  <div class="h-dialogContainer">
    <div class='left-width'>
      <ServerDetailLeft :detailShowList="detailShow" :detailInfo="detailInfo"></ServerDetailLeft>
    </div>
    <div class='right-width'>
      <div class='row h-row-insertBox' style="padding-right:0;">
        <div class='col-sm-6 h-col-insertBox'>
          <div class='h-inputLit'>{{$t('DeployManagement.environmentName')}}</div>
          <ejs-textbox class='e-input e-disabled' v-model='runEnvironment' disabled='false'></ejs-textbox>
        </div>
        <div class='col-sm-6 h-col-insertBox'>
          <div class='h-inputLit'>{{$t('DeployManagement.instanceName')}}</div>
          <ejs-textbox class='e-input e-input-group' v-model='instanceName' disabled='false'></ejs-textbox>
        </div>
      </div>
      <!-- <div class='row h-row-insertBox'>

        <div class='col-sm-6 h-col-insertBox'>
          <div class='h-inputLit'>{{this.$t('实例描述')}}</div>
          <ejs-textbox class='e-input e-input-group' v-model='instanceDes' disabled='false'></ejs-textbox>
        </div>
      </div> -->

      <div class='row h-row-insertBox' style="padding-right:0;">
        <div class='h-col-insertBox'>
          <div class='h-inputLit'>{{this.$t('Software.query_appVersion')}}</div>
          <ejs-grid ref='grid' :commandClick='onClick' :allowSelection='false'>
            <e-columns>
              <e-column field='deliverName' :headerText='$t("DeployManagement.deliverTypeStr")' width='90' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='deliverVersion' :headerText='$t("DeployManagement.version")' width='150' clipMode='EllipsisWithTooltip' textAlign='Middle'></e-column>
              <e-column field='exist' :headerText="$t('DeployManagement.hasPkg')" width='90' clipMode='EllipsisWithTooltip' textAlign='Middle'></e-column>
              <e-column :headerText="$t('DeployManagement.operate')" width='90' textAlign='Middle' clipMode='EllipsisWithTooltip' :commands='commands'></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CommandColumn  } from "@syncfusion/ej2-vue-grids";
import ServerDetailLeft from "../ServerDetailLeft";
import { EventBus } from '../../../plugins/eventBus';
import {stringify} from 'qs';
import SubscriberTool from "../../subscriberconfig/util/parseFormNew/tools/subscriberTool";

export default {
  name: 'ServerVersion',
  components: {
    ServerDetailLeft
  },
  provide: {
    grid: [ CommandColumn ]
  },
  data() {
    return {
      instanceName: '',
      instanceNum: '',
      instanceDes: '',
      runEnvironment: '',
      runEnvironmentId: '',
      node: '',
      neid: 0,
      envId: '',
      dpId: '',
      pkgVersion: '',
      dataSource: [],
      detailShow: [],
      detailInfo: {
        serviceName: '',
        description: '',
        deliverType: '',
        createTime: ''
      },
      detailShowMap: {
        description: this.$t('DeployManagement.description'),
        deliverType: this.$t('DeployManagement.deliverTypeStr'),
        createTime: this.$t('DeployManagement.lunchTime'),
        pkgVersion: this.$t('Software.td_packageVer'),
        type: this.$t('DeployManagement.classify')
      },
      commands: [{ buttonOption: { content: this.$t('DeployManagement.upgradeBtn'), cssClass: 'e-flat e-primary'}}],
      oamTypeCode: 0,
      upOrBack: 0,
      deliverMap: { // 交付方式 0:native 老的enb和epc包 / 1:image 镜像包 / 2:helm 5GC包
        0: 'native',
        1: 'image',
        2: 'helm'
      },
      existMap: {
        0: this.$t('DeployManagement.exist'),
        1: this.$t('DeployManagement.notExist')
      },
      oprMap: {
        0: this.$t('DeployManagement.upgradeBtn'),
        1: this.$t('DeployManagement.rebackBtn')
      },
      data: {},
      envItems: [],
    }
  },
  methods: {
    init(param) {
      // 初始参数赋值
      //console.log(param);
      const data = param['dataSource'];
      this.neid = data[0]['serviceId'];
      this.pkgVersion = data[0].version;
      this.dpId = data[0]['dpId'];
      this.id = data[0]['id'];
      this.oamTypeCode = param['oamTypeCode'];
      this.deliverType = data[0].deliverType;
      this.upOrBack = param['upOrBack'];
      this.instanceName = data[0]['dname'];
      this.instanceNum = data.length;
      this.runEnvironment = data[0]['runEnvironment'];
      this.runEnvironmentId = data[0]['runEnvironmentId'];
      this.envId = data[0]['envID'];
      this.instanceDes = '';
      this.node = '';
      this.dataSource = data;
      this.detailInfo = {
        serviceName: data[0]['typeValue'],
        deliverType: data[0]['deliverType'],
      };
      this.detailShow = [
        { name: this.detailShowMap['pkgVersion'], value: this.pkgVersion},
        { name: this.detailShowMap['createTime'], value: this.formatDateFilter(data[0].createTime)}
      ];
      this.commands[0]['buttonOption']['content'] = this.oprMap[this.upOrBack];
      // poc单独走升级逻辑
      if (this.deliverType === 1) {
        this.getMicroPocList();
      } else {
        this.getList();
      }
    },
    formatDateFilter(timeStamp) {
      const now = new Date(timeStamp);
      const year = now.getFullYear();  //取得4位数的年份
      const month = (Array(2).join('0') + (now.getMonth()+1)).slice(-2);  //取得日期中的月份，其中0表示1月，11表示12月
      const date = (Array(2).join('0') + now.getDate()).slice(-2);      //返回日期月份中的天数（1到31）
      const hour = (Array(2).join('0') + now.getHours()).slice(-2);     //返回日期中的小时数（0到23）
      const minute = (Array(2).join('0') + now.getMinutes()).slice(-2); //返回日期中的分钟数（0到59）
      const second = (Array(2).join('0') + now.getSeconds()).slice(-2); //返回日期中的秒数（0到59）
      return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
    },
    changeVersion() {
      const data = {};
      let url = '';
      const dpUpgradeInfo = [];
      if (this.detailInfo.deliverType === 0) {
        url = '/lte/ems/packageManager/backDevice';
        data['neIds'] = [this.neid];
      } else if (this.detailInfo.deliverType === 1) {
        url = '/lte/ems/packageManager/backDp';
        data['ids'] = this.dpId;
        data['envId'] = this.envId;
        dpUpgradeInfo.push({dpId:this.dataSource[0]['dpId']});
      } else {
        url = '/lte/ems/packageManager/back5gc';
        data['dpId'] = this.dpId;
        data['id'] = this.id;
        data['deliverVersion'] = this.data.deliverVersion;
        data['serviceId'] = this.envId;
        data['oamTypeCode'] = this.oamTypeCode;
      }
      this.$axios.post(url, data, {timeout: 60 * 4 * 1000}).then(res => {
        const result = res.data;
        if(result.errorCode == 'SUCCESS'){
          if(this.detailInfo.deliverType == 1){
            EventBus.$emit('toast', {type: "success", content: this.$t('DeployManagement.backOptTip')});
            EventBus.$emit('setUpgradeParam', {envId:this.envId, selected:dpUpgradeInfo});
          }else{
            EventBus.$emit('toast', {type: "success", content: this.$t('Common.tips.success')});
          }
        }else{
          EventBus.$emit('toast', {type: "error", content: res.data.errorString});
        }
      });
    },
    getMicroPocList(){
      const url = "/lte/ems/packageManager/findUpgradePkgForMicroPoc";
      const params = {
        envId: this.envId,
        oamTypeCode: this.oamTypeCode
      };
      this.axios.get(url, { params }).then(res => {
        const versionListObj = res.data;
        const versionShowList = [];
        Object.keys(versionListObj).forEach(version =>{
          /*if (version === this.pkgVersion) {
            return true;
          }*/
          const versionObj = {};
          versionObj.deliverName = this.deliverMap[1];
          versionObj.deliverVersion = version;
          versionObj.bigVersion = versionListObj[version];
          versionObj.exist = this.existMap[0];
          versionObj.dpId = this.dpId;
          versionShowList.push(versionObj);
        });
        //console.log('micro:versionShowList:', versionShowList);
        this.$refs.grid.ej2Instances.dataSource = versionShowList;
      });
    },
    getList() {
      const url = "/lte/ems/packageManager/findUpBackPackage";
      const params = {
        oamTypeCode: this.oamTypeCode,
        deliverType: this.deliverType
      };
      this.axios.get(url, { params }).then(res => {
        const result = res.data;
        const adapter = result.filter(item => item.pkgType === 0);
        const pkg = result.filter(item => item.pkgType === 1).map(item => {
          const { packageName, pkgVersion } = item;
          return {
            packageName,
            pkgVersion
          }});
        const serverPkg = result.filter(item => item.pkgType === 2).map(item => {
          const { packageName, pkgVersion } = item;
          return {
            packageName,
            pkgVersion
          }});
        const chartConfig = result.filter(item => item.pkgType === 3).map(item => {
          const { packageName, pkgVersion, chartPath, configPath } = item;
          return {
            packageName,
            pkgVersion,
            chartPath,
            configPath
          };
        });
        const showRe = [];
        adapter.forEach(item => {
          const re = { upVersion: [] };
          re.deliverType = item.deliverType;
          re.deliverName = this.deliverMap[item.deliverType];
          re.deliverVersion = item.pkgVersion;
          const tempN = pkg.filter(it => it.packageName === item.packageName);
          const tempS = serverPkg.filter(it => it.packageName === item.packageName);
          const tempConfig = chartConfig.filter(it => it.packageName === item.packageName);
          if (Object.keys(tempN).length === 2) {
            // native 类型，检查是否存在升级包pkg(2个)
            re.existNum = 0;
            re.pkgType = 1;
            re.upVersion = tempN.map(re => re.pkgVersion);
          } else if (Object.keys(tempS).length === 1) {
            // image/helm类型，检查是否存在软件包
            re.existNum = 0;
            re.pkgType = 2;
            re.upVersion = tempS.map(re => re.pkgVersion);
          } else {
            re.existNum = 1;
          }
          if (Object.keys(tempConfig).length === 1) {
            // chart，检查是否存在软件包
            re.existNum = 0;
            re.chartPath = tempConfig.map(re => re.chartPath)[0];
            re.configPath = tempConfig.map(re => re.configPath)[0];
          }
          re.exist = this.existMap[re.existNum];
          showRe.push(re);
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
      });
    },
    onClick(args) {
      this.data = args.rowData;
      if (this.data.existNum === 1) {//"软件包不存在，无法进行当前操作"
        this.eventEmit('warning', `${this.$t('DeployManagement.upgrading')}`);
        return null;
      }
      this.$layer.confirm({
        msg: this.data.deliverType === 0 ? this.$t('DeployManagement.deviceUpgrageConfirm') : this.$t('DeployManagement.upgrageConfirm'),
        btn2: {
          msg: this.$t('MCS.confirm'),
          func:()=>{
            this.confirm();
          }
        },
        btn1: {
          msg: this.$t('MCS.cancle'),
        }
      });
    },
    confirm(){
      let url = '';
      const params = this.getData();
      const data = {};
      const dpUpgradeInfo = [];
      //  升级
      if (this.deliverType === 0) {
        url = '/lte/ems/packageManager/upgradeDevice?' + stringify(params['urlParam']);
        data['neIds'] = [this.neid];
        data['versionList'] = params['data']['upVersion'];
      } else if (this.deliverType === 1) {
        url = '/lte/ems/packageManager/upgradeDp';
        data['ids'] = params['data']['dpId'];
        data['envId'] = this.envId;
        data['version'] = params['data']['bigVersion'];
        dpUpgradeInfo.push({dpId:params['data']['dpId']});
      } else {
        url = '/lte/ems/packageManager/upgrade5gc';
        data['serviceId'] = this.envId;
        data['oamTypeCode'] = this.oamTypeCode;
        data['dpId'] = this.dpId;
        data['id'] = this.id;
        data['deliverVersion'] = this.data.deliverVersion;
        data['model'] = {
          pkgVersion: params['data']['upVersion'][0],
          chartPath: params['data']['chartPath'],
          configPath: params['data']['configPath']
        };
      }
      this.$loading.showLoadding( this.$t('DeployManagement.upgrading'));
      this.$axios.post(url, data,{timeout: 60 * 4 * 1000}).then(res => {
        const result = res.data;
        this.$loading.hideLoadding();
        if (result && result.errorCode == 'SUCCESS') {
          if(this.deliverType == 1){
            this.eventEmit('success',this.$t('DeployManagement.upgradeOptTip'));
            EventBus.$emit('setUpgradeParam', {envId:this.envId, selected:dpUpgradeInfo});
          }else{
            this.eventEmit('success',`${this.$t('Common.tips.success')}`);
          }
        } else {
          //TODO 5gc升级 config配置不同需要额外处理
          if(this.deliverType == 2 && result.errorCode == '7901'){
            this.eventEmit('error',result.errorString);
            const param = {
              deployData:{
                chartPath : data.model.chartPath,
                configPath : data.model.configPath,
                pkgVersion : data.model.pkgVersion,
                deliverType : this.deliverMap[this.deliverType],
                createTime : this.detailShow[1].value,
                oamTypeCode : data.oamTypeCode,
                serviceName : this.detailInfo.serviceName,
              },
              upgradeData : {
                dpId: data.dpId,
                oamTypeCode:data.oamTypeCode,
                serviceId : data.serviceId,
                id : data.id,
                deliverVersion:data.deliverVersion,
                model:data.model
              }
            };
            EventBus.$emit('open5gcTemplate',param);
          }else{
            this.eventEmit('error',result.errorString);
          }
        }
      }).catch(err =>{
        this.$loading.hideLoadding();
        this.eventEmit('warn',`${this.$t('Common.tips.failure')}`);
      });
    },
    upgradeAfterConfig(param){
      param['configFlag'] = true;
      this.$loading.showLoadding( this.$t('DeployManagement.upgrading'));
      this.$axios.post('/lte/ems/packageManager/upgrade5gc', param,{timeout: 60 * 4 * 1000}).then(res => {
        this.$loading.hideLoadding();
        if (res.data.errorCode == 'SUCCESS') {
          this.eventEmit('success',`${this.$t('Common.tips.success')}`);
        } else {
          this.eventEmit('error',res.data.errorString);
        }
      }).catch(err =>{
        this.$loading.hideLoadding();
        this.eventEmit('warn',`${this.$t('Common.tips.failure')}`);
      });
    },
    getData() {
      const params = {
        data: this.data,
        urlParam: {
          //  native 服务需要设置 isDownLoad, isActive, isUpLoad, execTime, isFilter 字段
          isDownLoad: 1,
          isActive: 1,
          isUpLoad: 1,
          isFilter: 0
        }
      };
      return params;
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  },
}
</script>

<style scoped>
.left-width{
  height:100%;width:240px;float:left;
}
.right-width{
  width:calc(100% - 240px);float:left;height:100%;
}
</style>
